<script setup lang="ts">
	import { useI18n } from 'vue-i18n';
	import { ref, Ref } from 'vue';
	import { useIntervalFn } from '@vueuse/core';
	import { MzButton, MzLink } from '@monizze/monizze-components';

	const { t } = useI18n();

	const emit = defineEmits<{
		(e: 'resend'): void;
	}>();

	const {
		method,
		time,
		type = 'button',
		textStyle = '',
	} = defineProps<{
		method: string;
		time: number;
		type?: 'button' | 'text';
		textStyle?: string;
	}>();

	const resendTimer: Ref<number> = ref(time);

	const { pause, resume, isActive } = useIntervalFn(() => {
		if (resendTimer.value > 0) resendTimer.value--;
		else {
			pause();
		}
	}, 1000);

	const resumeResend = () => {
		emit('resend');
		resendTimer.value = 15;
		resume();
	};
</script>

<template>
	<div v-if="type === 'button'" class="flex flex-col gap-3 sm:flex-row items-center">
		<p :class="textStyle">{{ t('duplicated2fa.page.not_received') }}</p>
		<mz-button
			width="auto"
			:label="isActive ? t(`duplicated2fa.page.resend_${method}_timer`) + ` (${resendTimer})` : t(`duplicated2fa.page.resend_${method}`)"
			:disabled="isActive"
			variant="outline"
			@click.prevent="resumeResend"
		/>
	</div>
	<p v-else :class="textStyle">
		{{ t('duplicated2fa.page.not_received') }}
		<mz-link
			:label="isActive ? t(`duplicated2fa.page.resend_sms_timer`) + ` (${resendTimer})` : t(`duplicated2fa.page.resend_sms`)"
			:class="isActive ? 'hover:opacity-100 pointer-events-none' : ''"
			:disabled="isActive"
			href="#"
			target="_self"
			@click.prevent="!isActive && resumeResend()"
		/>
	</p>
</template>
